/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SWAPVAULTNFT, SWAPVAULTNFTInterface } from "../SWAPVAULTNFT";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "tokenURI",
        type: "string",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type SWAPVAULTNFTConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SWAPVAULTNFTConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SWAPVAULTNFT__factory extends ContractFactory {
  constructor(...args: SWAPVAULTNFTConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SWAPVAULTNFT";
  }

  deploy(
    _name: string,
    _symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SWAPVAULTNFT> {
    return super.deploy(
      _name,
      _symbol,
      overrides || {}
    ) as Promise<SWAPVAULTNFT>;
  }
  getDeployTransaction(
    _name: string,
    _symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_name, _symbol, overrides || {});
  }
  attach(address: string): SWAPVAULTNFT {
    return super.attach(address) as SWAPVAULTNFT;
  }
  connect(signer: Signer): SWAPVAULTNFT__factory {
    return super.connect(signer) as SWAPVAULTNFT__factory;
  }
  static readonly contractName: "SWAPVAULTNFT";
  public readonly contractName: "SWAPVAULTNFT";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SWAPVAULTNFTInterface {
    return new utils.Interface(_abi) as SWAPVAULTNFTInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SWAPVAULTNFT {
    return new Contract(address, _abi, signerOrProvider) as SWAPVAULTNFT;
  }
}
